module.exports = __webpack_public_path__ + "img/guan.b63138b9.png";